// ---------------------------------------------------------------------------
// Exploration routes
//
// Every page about one exploration carries its id in the URL:
//
//     /colorexplorations/<explorationId>/<step>
//
// so two browser tabs can hold two explorations without either one being
// confused about which it shows. The list and the New exploration page (no
// exploration exists yet) live under their own paths.
// ---------------------------------------------------------------------------
export const EXPLORATION_LIST_ROUTE = "/colorexplorationhome";

/** The New exploration page: every choice on one page, the draft in its
 *  React state (pages/colorExploration/ColorExplorationSetup.js). The old
 *  wizard step URLs (/colorexplorationsetup/<step>) redirect here. */
export const EXPLORATION_SETUP_ROUTE = "/colorexplorationsetup";

/** The steps of an existing exploration: the three measurement pages of the
 *  running iteration, its results and the analysis of the whole run. */
export const EXPLORATION_STEPS = ["resolution", "width", "color", "summary", "analyse"];
export const EXPLORATION_BASE = "/colorexplorations";
export function explorationRoute(explorationId, step) {
    return `${EXPLORATION_BASE}/${explorationId}/${step}`;
}

/** Where an exploration continues, by its status - or the Results page
 *  when the backend says the results are ready (``results_ready``: the
 *  population in work is fully colour-measured and the next generation has
 *  not been prepared yet). That is where the next generation is chosen, and
 *  the status alone cannot tell this state from "colour still to measure". */
export function explorationResumeRoute(explorationId, status, resultsReady = false) {
    if (resultsReady) {
        return explorationRoute(explorationId, "summary");
    }
    switch ((status || "").toUpperCase()) {
        // WIDTH_MEASUREMENT_DONE means the cluster widths are saved but
        // mark/collection has not run yet (no FULL_CLUSTER rows). Sending
        // the user to the color upload page in that state used to crash
        // measure_color the moment they clicked "Next" on a color image.
        // Route them to the width review page instead - clicking "Next"
        // there triggers mark/collection and advances to FULL_CLUSTER_MARKED.
        case "WIDTH_MEASUREMENT_DONE":
            return explorationRoute(explorationId, "width");
        case "FULL_CLUSTER_MARKED":
            return explorationRoute(explorationId, "color");
        case "COMPLETED":
            return explorationRoute(explorationId, "summary");
        case "COLOR_MEASUREMENT_DONE":
        case "PENDING":
        default:
            return explorationRoute(explorationId, "resolution");
    }
}
